import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const track = (event, params = {}) => {
  if (typeof window !== "undefined" && typeof window.gtag === "function") window.gtag("event", event, params);
};

// Backend'den gelen "/api/..." ile baslayan yollari guvenle mutlak URL'ye cevirir (cift /api onlemi)
export const absoluteUrl = (path) =>
  path?.startsWith("/api") ? `${process.env.REACT_APP_BACKEND_URL}${path}` : `${API}${path}`;

export function formatApiError(err, fallback = "Something went wrong") {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}
